import { createContext } from "react";

const LoaderContext = createContext({});

export default LoaderContext;
